import { render, staticRenderFns } from "./Milestones.vue?vue&type=template&id=52e1e0af"
import script from "./Milestones.vue?vue&type=script&lang=js"
export * from "./Milestones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports